import AdditionalServiceCategories from "@/views/premium-services/premium-service-categories/PremiumServiceCategories.vue";
import ConciergeServiceCreateDlg from "@/views/concierge/concierge-service-create-dlg/ConciergeServiceCreateDlg.vue";
import { batchUpdate } from "@/utils/batchUpdate";
import { ConciergeServicesListMixin } from "@/mixins/ConciergeServicesList.ts";

export default {
  name: "ConciergeProducts",
  components: {
    AdditionalServiceCategories,
    ConciergeServiceCreateDlg,
  },
  mixins: [ConciergeServicesListMixin],
  computed: {
    serviceType() {
      return this.premiumServiceEventTypes.Product
    },
    additionalServices() {
      return this.$store.state.additionalServicesModule.additionalServices?.filter(x => [
        this.premiumServiceEventTypes.Gift,
        this.premiumServiceEventTypes.Product,
      ].includes(x.type));
    },
    conciergeProducts() {
      const categoryObj = this.serviceCategories.find(x => x.name === this.category);

      let additionalServices = this.category && this.category !== 'All' && categoryObj && categoryObj?.id
        ? this.additionalServices?.filter(service => service.categoryId === categoryObj?.id)
        : this.additionalServices;

      additionalServices = this.search
        ? additionalServices?.filter(service => service.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
        : additionalServices;

      return additionalServices.map((service) => ({
        id: service.id,
        image: service.imageUrl,
        name: service.name,
        category: service?.category,
        categoryId: service.categoryId,
        price: service.subscriptionCost,
        appointmentBased: service.type === this.premiumServiceEventTypes.ByAppointment ? 'Y' : 'N',
        pending: this.serviceRequestsAwaiting?.filter(x => x.serviceId === service.id).length,
        orderIndex: service.orderIndex,
        serviceType: service.serviceType,
        oneOffCost: service.oneOffCost,
        subscriptionCost: service.subscriptionCost,
        participantLimitNumber: service?.participantLimitNumber ? service.participantLimitNumber : '-',
        participantLimit: service.participantLimit ?? null
      }))?.sort((a, b) => {
        if(a.orderIndex < b.orderIndex) { return -1; }
        if(a.orderIndex > b.orderIndex) { return 1; }
        return 0;
      })
    },
  },
  methods: {
    async updateProducts() {
      this.loading = true;

      const itemsToUpdate = this.conciergeProducts.map((item, index) => {
        return { docId: item.id, updates: { orderIndex: index + 1 } };
      })

      await batchUpdate('additionalServices', itemsToUpdate).then(() => {
        this.loading = false;
      })
    }
  }
}
